import BaseAnnotationLayer from "./BaseAnnotationLayer";
import {onIHCResultSelect} from "../utils/ihc_app_utils";

class IHCResultLayer extends BaseAnnotationLayer {
	id = "ihc-result";
	label = "IHC Result Layer";
	tools = [];
	onFeatureSelect = (feature) => onIHCResultSelect(this.props.map.get('id'), feature);
	onFeatureHover = () => null;
	style = feature => {
		let annoStyle = this.baseStyle;
		if (feature.getProperties().color) {
			annoStyle.getStroke().setColor(feature.getProperties().color);
		}
		annoStyle.getStroke().setWidth(2);
		if (feature.getProperties().selected)
			return [this.selectedStyle, annoStyle]
		return [this.otherStyle, annoStyle]
	}
}

export default IHCResultLayer;
